import script from "./CreateLocationUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateLocationUsers.vue?vue&type=script&setup=true&lang=js"

import "./CreateLocationUsers.vue?vue&type=style&index=0&id=21073f02&lang=scss"

const __exports__ = script;

export default __exports__